import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { URLS } from '@shared-config/urls';
import { FileDataUpload } from '@shared-interfaces/shared-file';
import { UploadProcessResponse } from '@shared-interfaces/shared-upload';
import {Observable, Subscription} from 'rxjs';


@Injectable({
  providedIn: 'root',
})
export class UploadService {
  private httpClient = inject(HttpClient);

  constructor() {}

  // API requests
  getSignedUrl(file: FileDataUpload): Observable<UploadProcessResponse> {
    let file_extension: string = file.file.name.split('.').pop()
    let identifier: string = file.workflowId? file.workflowId: "";
    return this.httpClient
      .get<UploadProcessResponse>(
        `${URLS.UPLOAD_FILE}/${file.workflowId}`,
        {
          params: {
            original_filename: file.file.name.split('.')[0],
            file_extension: file_extension.toLowerCase(),
            process_details: identifier,
          }
        }
      )
  }

  uploadToSignedUrl(file: File, signedUrl: string) {
    const headers = new HttpHeaders({
      'Content-Type': 'application/octet-stream',
    });

    return this.httpClient.put(signedUrl, file, { headers });
  }

  updateFiles(fileName?: string) {
    return this.httpClient.put(URLS.UPDATE_FILE, fileName || '').subscribe(() => {});
  }

  public deleteFile(workflowId: string, fileStoredName: string): Subscription {
    return this.httpClient.post(`${URLS.EXECUTION}/delete_file_from_contract`, {
        content_collection_id: workflowId,
        file_ids: [fileStoredName]
      })
      .subscribe(() => {});
  }
}
